import React from "react";

export const EntityMenuContext = React.createContext<React.ReactNode>(null);
